<section
  *ngIf="{
    isLayoutHidden: isLayoutHidden$ | async,
    isWindowAtTop: isWindowAtTop$ | async,
    isSmallScreen: isSmallScreen$ | async,
    closeSmallScreenSidebarOnRouteChange:
      closeSmallScreenSidebarOnRouteChange$ | async,
    onToggleMenu: onToggleMenu$ | async,
    isLoadingSupersetOAuthData: isLoadingSupersetOAuthData()
  } as State"
  class="content-wrapper"
>
  <mat-toolbar
    #toolbar
    *ngIf="!State.isLayoutHidden && State.isSmallScreen"
    color="secondary"
    class="mat-elevation-z6"
  >
    <div class="flex items-center gap-2 flex-grow overflow-hidden">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer()?.toggle()"
      >
        <mat-icon svgIcon="dgi-menu" color="primary"></mat-icon>
      </button>
      <button
        (click)="navigateToSuperset()"
        type="button"
        button
        variant="primaryLight"
        [loading]="!!State.isLoadingSupersetOAuthData"
        loadingText="Redirection en cours..."
        size="md"
      >
        <mat-icon
          [svgIcon]="'dgi-market-analysis-stroke-rounded'"
          color="primary"
        ></mat-icon>
        <span class="hidden sm:inline">Accès à la BI</span>
      </button>
      <button
        (click)="navigateToPortal()"
        type="button"
        button
        variant="secondaryOutline"
        size="md"
      >
        <mat-icon [svgIcon]="'dgi-msg'"></mat-icon>
        <span class="hidden sm:inline">Aller à la messagerie</span>
      </button>
    </div>

    <a [routerLink]="'/'">
      <img
        [lazyLoad]="'assets/images/cdilogo.png'"
        class="w-10 lg:w-[50px]"
        width="50"
        alt="DGI logo"
      />
    </a>
  </mat-toolbar>

  <mat-sidenav-container autosize>
    <mat-sidenav
      *ngIf="!State.isLayoutHidden"
      class="sidenav"
      [ngClass]="isSidenavCollapsed ? 'sidenav--collapsed' : ''"
      fixedInViewport
      [attr.role]="State.isSmallScreen ? 'dialog' : 'navigation'"
      [mode]="State.isSmallScreen ? 'over' : 'side'"
      [opened]="State.isSmallScreen || State.isLayoutHidden ? false : true"
      [style.margin-top.px]="toolbarHeight"
    >
      <a [routerLink]="'/'" class="sidenav__logo">
        <img [lazyLoad]="'assets/images/cdilogo.png'" alt="DGI logo" />

        <h1 class="sidenav__logo-title">ESPACE D'ADMINISTRATION DGI</h1>
      </a>

      @if (isSandboxEnvironment) {
        <div class="sidebar-ribbon">Sandbox</div>
      }

      <div class="sidenav__menu">
        <mat-list class="sidenav__menu-links">
          <ng-container *ngFor="let link of sidebarLinks">
            <ng-container *ngxPermissionsOnly="link.permissions ?? []">
              <div *ngIf="link.sectionTitle" class="sidenav__title-wrapper">
                <span class="sidenav__title">
                  {{ link.sectionTitle }}
                </span>
              </div>

              <a
                mat-list-item
                [routerLink]="link.enabled !== false ? link.url : undefined"
                [class.sidenav__menu-item--disabled]="link.enabled === false"
                [routerLinkActive]="
                  link.enabled !== false ? 'mdc-list-item--active' : ''
                "
                [routerLinkActiveOptions]="{
                  exact: link.exactActive ?? false
                }"
                [matTooltip]="link.tooltip || link.label"
                matTooltipPosition="after"
                (click)="link.enabled === false && $event.preventDefault()"
              >
                <mat-icon
                  class="mdc-list-item__icon"
                  [svgIcon]="'dgi-' + link.icon"
                  color="primary"
                ></mat-icon>
                <span class="mdc-list-item__label">{{ link.label }}</span>
                <!-- <small *ngIf="link.hasBadge" class="badge">4</small> -->
              </a>
            </ng-container>
          </ng-container>
        </mat-list>
      </div>

      <div class="sidenav__menu-card">
        <div class="sidenav__menu-card-icon-wrapper">
          <span class="sidenav__menu-card-icon">?</span>
        </div>

        <p class="sidenav__menu-card-title">Besoin d'aide ?</p>
        <p class="sidenav__menu-card-description">
          Des difficultés avec la plateforme ? Veuillez consulter la
          documentation pour plus d'informations
        </p>
        <a
          href="https://docs.fneci.net"
          target="_blank"
          rel="noopener noreferrer"
          role="button"
          >Documentation</a
        >
      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <main
        class="content-wrapper__content"
        [style.padding-top.px]="
          !State.isLayoutHidden && State.isSmallScreen ? 0 : toolbarHeight
        "
      >
        <toolbar *ngIf="!State.isLayoutHidden"></toolbar>
        <div class="content-wrapper__content-main">
          <router-outlet></router-outlet>
        </div>

        <admin-footer></admin-footer>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</section>
